import {
  jb_close_icon_css_default
} from "./chunk.PGJHOEXJ.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-close-icon/jb-close-icon.ts
var JbCloseIcon = class extends Icon(i) {
  render() {
    return b`
      <svg
        viewbox="0 0 30 29"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          stroke="none"
          stroke-width="1"
          fill-rule="evenodd"
        >
          <g transform="translate(-1825.000000, -45.000000)">
            <g transform="translate(1820.000000, 45.000000)">
              <path
                d="M19.2926829,14.5 L5.5,0.707317073 L6.20731707,-2.1151414e-12 L20,13.7926829 L33.7926829,-2.11031193e-12 L34.5,0.707317073 L20.7073171,14.5 L34.5,28.2926829 L33.7926829,29 L20,15.2073171 L6.20731707,29 L5.5,28.2926829 L19.2926829,14.5 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    `;
  }
};
JbCloseIcon.styles = [reset_css_default, jb_close_icon_css_default];
JbCloseIcon = __decorateClass([
  customElement("jb-close-icon")
], JbCloseIcon);

export {
  JbCloseIcon
};
